import React from 'react'
import { Link } from 'react-router-dom'
import { checkLogoutUser } from '../../redux/actions/userActions'
import './Dashboard.css'
import { useAppDispatch } from '../../store'

function Dashboard({ url }: { url: string }) {
  const dispatch = useAppDispatch()
  const handleLogout = () => {
    dispatch(checkLogoutUser())
    window.location.href = '/'
  }
  return (
    <div className="panel--header">
      <Link to="/admin" className="logoAdmin">
        B-shop Panel
      </Link>
      <ul>
        <li>
          <Link to={`${ url }/products`}>Products</Link>
        </li>
        <li>
          <Link to={`${ url }/new-product`}>Add Product</Link>
        </li>
        <li>
          <Link to={`${ url }/cate`}>Categories</Link>
        </li>
        <li>
          <Link to={`${ url }/new-cate`}>Add Category</Link>
        </li>
        <li>
          <Link to={`${ url }/orders`}>Orders</Link>
        </li>
        <li>
          <Link to="/logout" onClick={handleLogout}>
            Logout
          </Link>
        </li>
      </ul>
    </div>
  )
}

export default Dashboard
